<template>
  <div>
    <!-- 箱号选择弹窗 -->
    <job-container-no-select-dialog
      :visible.sync="jobContainerNoSelectDialog.visible"
      :job-uuid="jobContainerNoSelectDialog.jobUuid"
      :container-no-list="jobContainerNoSelectDialog.containerNoList"
      :include-ex-change-agent="jobContainerNoSelectDialog.includeExChangeAgent"
      @callback="onSelectContainerNo"
    />
    <!-- 换单代理选择弹窗 -->
    <exchange-agent-select-dialog
      :visible.sync="exchangeAgentSelectDialog.visible"
      :job-uuid="exchangeAgentSelectDialog.jobUuid"
      :exchange-agents="exchangeAgentSelectDialog.exchangeAgents"
      @callback="onSelectExchangeAgent"
    />
    <!-- 【委托拼箱】发送目的港代理邮件选择弹窗 -->
    <destination-agent-select-dialog
      v-if="destinationAgentSelectDialog.visible"
      :visible.sync="destinationAgentSelectDialog.visible"
      :row-data="destinationAgentSelectDialog.rowData"
      :total="jobs.length"
      :job-count="jobs.length"
      @callback="onSelectDestinationAgent"
    />
    <!-- 发送目的港代理邮件校验弹窗 -->
    <checking-send-destination-agent-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :is-pass="checkingWindow.isPass"
      :master-info="checkingWindow.masterInfo"
      :slave-info="checkingWindow.slaveInfo"
      :row-data="checkingWindow.rowData"
      :show-next="checkingWindow.showNext"
      :match-instruction-tip="checkingWindow.matchInstructionTip"
      :title="checkingWindow.title"
      :multi-field-sample="checkingWindow.multiFieldSample"
      @next="sendDestinationPortAgentNext"
    />
    <!-- 发送目的港代理邮件弹窗 -->
    <send-destination-port-agent-email-dialog
      v-if="sendDestinationPortAgentEmailDialog.visible"
      :visible.sync="sendDestinationPortAgentEmailDialog.visible"
      :job="job"
      :file-list="fileList"
      :push-link="pushLink"
      :mail-template-uuid="mailTemplateUuid"
      :exchange-agent-data="sendDestinationPortAgentEmailDialog.exchangeAgentData"
      :job-container-no-data="sendDestinationPortAgentEmailDialog.jobContainerNoData"
      :file-type-of-take-multi="fileTypeOfTakeMulti"
      :tenant-instruction="tenantInstruction"
      :rule-name="ruleName"
      :resend="resend"
      @callback="sendDestinationPortAgentCallback"
      @instructionCallback="data => instructionCallback(Object.assign({ instructionUuid: tenantInstruction.uuid }, data))"
    />
    <!-- 【委托拼箱】发送目的港代理邮件弹窗 -->
    <send-destination-port-agent-email-multi-dialog
      v-if="sendDestinationPortAgentEmailMultiDialog.visible"
      :visible.sync="sendDestinationPortAgentEmailMultiDialog.visible"
      :job="sendDestinationPortAgentEmailMultiDialog.job"
      :jobs="sendDestinationPortAgentEmailMultiDialog.jobs"
      :file-list="fileList"
      :push-link="pushLink"
      :mail-template-uuid="mailTemplateUuid"
      :destination-agent="sendDestinationPortAgentEmailMultiDialog.destinationAgent"
      :file-type-of-take-multi="fileTypeOfTakeMulti"
      :tenant-instruction="tenantInstruction"
      :rule-name="ruleName"
      :resend="resend"
      @callback="sendDestinationPortAgentMultiCallback"
      @instructionCallback="data => instructionCallback(Object.assign({ instructionUuid: tenantInstruction.uuid }, data))"
    />
  </div>
</template>

<script>
import ExchangeAgentSelectDialog from '@/components/Cargo/Job/booking/tabs/ExchangeAgentSelectDialog'
import DestinationAgentSelectDialog from '@/components/Cargo/Job/booking/tabs/DestinationAgentSelectDialog'
import CheckingSendDestinationAgentWindow from '@/components/Cargo/Job/CheckingManager/CheckingSendDestinationAgentWindow'
import SendDestinationPortAgentEmailDialog from '@/components/Cargo/Job/SendDestinationPortAgentEmailDialog'
import SendDestinationPortAgentEmailMultiDialog from '@/components/Cargo/Job/SendDestinationPortAgentEmailMultiDialog'
import JobContainerNoSelectDialog from '@/components/Cargo/Job/instructionManager/JobContainerNoSelectDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { checkSendDestinationPortAgent, checkSendDestinationPortAgentMulti } from '@/api/sysManage/baseConfig/checkRuleConfig'
import { generateInstructionRecord } from '@/api/sysManage/baseConfig/instruction'
import { getExChangeAgentsByJobUuid, getSlaveJobsAndContainers, resetOneClickSend } from '@/api/booking/job'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import DateUtils from '@/utils/dateUtils'
import lodash from 'lodash'
import { Job } from '@/class/model/booking/Job'

// 数据发送维度-箱子维度
const DATA_SEND_DIMENSION_CONTAINER = '箱子维度'

export default {
  name: 'OneClickSendWindow',
  components: { ExchangeAgentSelectDialog, DestinationAgentSelectDialog, CheckingSendDestinationAgentWindow, SendDestinationPortAgentEmailDialog, SendDestinationPortAgentEmailMultiDialog, JobContainerNoSelectDialog },
  props: {
    fileTypeCapsMap: {
      type: Map,
      required: true
    }
  },
  data() {
    return {
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      }, // 租户操作指令
      mailTemplateUuid: '', // 邮件模板UUID
      pushLink: '',
      ruleName: '',
      fileTypeOfTakeMulti: '', // 该文件类型，不同名称各抽取最新的文件
      dataSendDimension: '', // 数据发送维度
      resend: false, // 是否为补发
      jobs: [],
      job: {},
      forecastResend: null,
      fileList: [],
      trackingCode: '',
      isBatch: false,
      jobContainerNoSelectDialog: {
        visible: false,
        jobUuid: '',
        containerNoList: [],
        includeExChangeAgent: false,
        selectData: null
      },
      exchangeAgentSelectDialog: {
        visible: false,
        jobUuid: '',
        exchangeAgents: [],
        selectData: null
      },
      destinationAgentSelectDialog: {
        visible: false,
        rowData: [],
        jobsGroupByDestinationAgent: null
      },
      checkingWindow: {
        visible: false,
        isPass: false,
        masterInfo: '',
        slaveInfo: '',
        rowData: [],
        showNext: false,
        matchInstructionTip: '',
        title: '',
        multiFieldSample: null
      },
      sendDestinationPortAgentEmailDialog: {
        visible: false,
        exchangeAgentData: null,
        jobContainerNoData: null
      },
      sendDestinationPortAgentEmailMultiDialog: {
        visible: false,
        jobs: [],
        job: {},
        destinationAgent: 0
      }
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, job, fileList) {
      this.isSop = false
      this.tenantInstruction.uuid = uiInstruction.tenantInstructionUuid
      this.tenantInstruction.platformInstructionCode = uiInstruction.platformInstructionRuleCode
      this.tenantInstruction.allowMultipleOperations = uiInstruction.allowMultipleOperations || false
      if (uiInstruction.instructionRuleJson) {
        this.mailTemplateUuid = uiInstruction.instructionRuleJson.mailTemplateUuid || ''
        this.pushLink = uiInstruction.instructionRuleJson.pushLink || ''
      } else {
        this.mailTemplateUuid = ''
        this.pushLink = ''
      }
      if (uiInstruction.instructionParamJson) {
        this.ruleName = uiInstruction.instructionParamJson.ruleName || ''
        this.fileTypeOfTakeMulti = uiInstruction.instructionParamJson.fileTypeOfTakeMulti || ''
        this.dataSendDimension = uiInstruction.instructionParamJson.dataSendDimension || ''
        this.resend = uiInstruction.instructionParamJson.resend === '1'
      } else {
        this.ruleName = ''
        this.fileTypeOfTakeMulti = ''
        this.dataSendDimension = ''
        this.resend = false
      }
      this.jobs = [job]
      this.job = job
      this.fileList = fileList ? Array.from(fileList, p => ({ fileId: p.fileId, fileName: p.fileName, createDate: p.createDate, jobNo: p.jobNo })) : []
      this.trackingCode = ''
      this.isBatch = false
      this.forecastResend = null
      this.jobContainerNoSelectDialog.selectData = null
      this.exchangeAgentSelectDialog.selectData = null
      switch (this.tenantInstruction.platformInstructionCode) {
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT.code:
          if (!this.pushLink) {
            this.pushLink = String(SystemConstants.SEND_DESTINATIOIN_PORT_AGENT)
          }
          // 【自拼箱】发送目的港代理
          if (this.dataSendDimension === DATA_SEND_DIMENSION_CONTAINER) {
            this.showContainerNoSelectDialog(false)
          } else {
            this.sendDestinationPortAgent()
          }
          break
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT.code:
          // 【委托拼箱】发送目的港代理
          this.bbSendDestinationPortAgent()
          break
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code:
          if (!this.pushLink) {
            this.pushLink = String(SystemConstants.SEND_PACKAGE_AGENT)
          }
          // 【自拼箱】发送套单代理
          if (this.dataSendDimension === DATA_SEND_DIMENSION_CONTAINER) {
            this.showContainerNoSelectDialog(true)
          } else {
            this.sendPackageAgent()
          }
          break
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_RESET_ONE_CLICK_SEND.code:
          // 重置一键发送
          this.resetOneClickSend()
          break
        default:
          break
      }
    },
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs, trackingCode, isBatch = false) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionRuleJson) {
        this.mailTemplateUuid = sopInstruction.instructionRuleJson.mailTemplateUuid || ''
        this.pushLink = sopInstruction.instructionRuleJson.pushLink || ''
      } else {
        this.mailTemplateUuid = ''
        this.pushLink = ''
      }
      if (sopInstruction.instructionParamJson) {
        this.ruleName = sopInstruction.instructionParamJson.ruleName || ''
        this.fileTypeOfTakeMulti = sopInstruction.instructionParamJson.fileTypeOfTakeMulti || ''
        this.dataSendDimension = sopInstruction.instructionParamJson.dataSendDimension || ''
        this.resend = sopInstruction.instructionParamJson.resend === '1'
      } else {
        this.ruleName = ''
        this.fileTypeOfTakeMulti = ''
        this.dataSendDimension = ''
        this.resend = false
      }
      this.jobs = jobs
      this.job = jobs[0]
      this.fileList = []
      this.trackingCode = trackingCode
      this.isBatch = isBatch
      if (this.job.forecastResendMap) {
        this.forecastResend = this.job.forecastResendMap[sopInstruction.platformInstructionCode] || null
      } else {
        this.forecastResend = null
      }
      this.jobContainerNoSelectDialog.selectData = null
      this.exchangeAgentSelectDialog.selectData = null
      switch (this.tenantInstruction.platformInstructionCode) {
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT.code:
          if (jobs.length > 1) {
            this.$message.error(this.$t('CargoMsg.Cargo_LclSendDestinationPortAgentTip'))
            return
          }
          if (!this.pushLink) {
            this.pushLink = String(SystemConstants.SEND_DESTINATIOIN_PORT_AGENT)
          }
          // 【自拼箱】发送目的港代理
          if (this.resend && this.forecastResend) {
            this.showForecastResend()
          } else if (this.dataSendDimension === DATA_SEND_DIMENSION_CONTAINER) {
            this.showContainerNoSelectDialog(false)
          } else {
            this.sendDestinationPortAgent()
          }
          break
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT.code:
          // 【委托拼箱】发送目的港代理
          this.bbSendDestinationPortAgent()
          break
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code:
          if (jobs.length > 1) {
            this.$message.error(this.$t('CargoMsg.Cargo_LclSendPackageAgentTip'))
            return
          }
          if (!this.pushLink) {
            this.pushLink = String(SystemConstants.SEND_PACKAGE_AGENT)
          }
          // 【自拼箱】发送套单代理
          if (this.resend && this.forecastResend) {
            this.showForecastResend()
          } else if (this.dataSendDimension === DATA_SEND_DIMENSION_CONTAINER) {
            this.showContainerNoSelectDialog(true)
          } else {
            this.sendPackageAgent()
          }
          break
        default:
          break
      }
    },
    showForecastResend() {
      if (this.forecastResend.containerNo) {
        this.dataSendDimension = DATA_SEND_DIMENSION_CONTAINER
        const containerNoList = [{
          containerNo: this.forecastResend.containerNo,
          exchangeAgent: this.forecastResend.exchangeAgent,
          jobKeys: [this.forecastResend.jobUuid]
        }]
        this.jobContainerNoSelectDialog.containerNoList = containerNoList
        this.jobContainerNoSelectDialog.includeExChangeAgent = !!this.forecastResend.exchangeAgent
        this.jobContainerNoSelectDialog.jobUuid = this.job.uuid
        this.jobContainerNoSelectDialog.selectData = null
        this.onSelectContainerNo(containerNoList[0])
      } else if (this.forecastResend.exchangeAgent) {
        this.exchangeAgentSelectDialog.exchangeAgents = [this.forecastResend.exchangeAgent]
        this.exchangeAgentSelectDialog.jobUuid = this.job.uuid
        this.exchangeAgentSelectDialog.selectData = null
        this.onSelectExchangeAgent({ uuid: '', exchangeAgent: this.forecastResend.exchangeAgent, sendTime: '', allowAgainSend: false })
      } else {
        this.sendDestinationPortAgent()
      }
    },
    async showContainerNoSelectDialog(includeExChangeAgent) {
      let lclSlaves = null
      let containers = null
      if (this.job.lclSlaves && this.job.containers) {
        lclSlaves = this.job.lclSlaves
        containers = this.job.containers
      } else {
        await getSlaveJobsAndContainers({ jobUuid: this.job.uuid }).then(res => {
          lclSlaves = res.data.slaveJobs
          containers = res.data.contaners
        })
      }
      const slaveMap = new Map()
      for (const slave of lclSlaves) {
        slaveMap.set(slave.uuid, slave)
      }
      const containerJobsMap = new Map()
      const containerNoList = []
      for (const container of containers) {
        if (!container.containerNo) {
          continue
        }
        if (!containerJobsMap.has(container.containerNo)) {
          const containerNoItem = {
            containerNo: container.containerNo,
            exchangeAgent: 0,
            jobKeys: []
          }
          containerNoList.push(containerNoItem)
          containerJobsMap.set(container.containerNo, containerNoItem)
        }
        if (!container.containerUsage) {
          continue
        }
        for (const containerUserage of container.containerUsage) {
          if (!containerUserage.jobUuid) {
            continue
          }
          const slave = slaveMap.get(containerUserage.jobUuid)
          if (!slave) {
            continue
          }
          containerJobsMap.get(container.containerNo).jobKeys.push(containerUserage.jobUuid)
          if (!slave.exChangeAgent) {
            continue
          }
          if (!containerJobsMap.has(container.containerNo + '-' + slave.exChangeAgent)) {
            const containerNoItem = {
              containerNo: container.containerNo,
              exchangeAgent: slave.exChangeAgent,
              jobKeys: []
            }
            containerNoList.push(containerNoItem)
            containerJobsMap.set(container.containerNo + '-' + slave.exChangeAgent, containerNoItem)
          }
          containerJobsMap.get(container.containerNo + '-' + slave.exChangeAgent).jobKeys.push(containerUserage.jobUuid)
        }
      }
      this.jobContainerNoSelectDialog.containerNoList = containerNoList.filter(p => p.jobKeys.length > 0)
      this.jobContainerNoSelectDialog.includeExChangeAgent = includeExChangeAgent
      this.jobContainerNoSelectDialog.jobUuid = this.job.uuid
      this.jobContainerNoSelectDialog.selectData = null
      this.jobContainerNoSelectDialog.visible = true
    },
    onSelectContainerNo(data) {
      this.jobContainerNoSelectDialog.selectData = data
      this.sendDestinationPortAgent()
    },
    async sendPackageAgent() {
      if (this.job.lclSlaves) {
        const exchangeAgentSet = new Set()
        if (this.job.exChangeAgent) {
          exchangeAgentSet.add(this.job.exChangeAgent)
        }
        for (const slave of this.job.lclSlaves) {
          if (slave.exChangeAgent) {
            exchangeAgentSet.add(slave.exChangeAgent)
          }
        }
        this.exchangeAgentSelectDialog.exchangeAgents = [...exchangeAgentSet]
      } else {
        await getExChangeAgentsByJobUuid({ jobUuid: this.job.uuid }).then(res => {
          this.exchangeAgentSelectDialog.exchangeAgents = res.data
        })
      }
      this.exchangeAgentSelectDialog.jobUuid = this.job.uuid
      this.exchangeAgentSelectDialog.selectData = null
      this.exchangeAgentSelectDialog.visible = true
    },
    onSelectExchangeAgent(data) {
      this.exchangeAgentSelectDialog.selectData = data
      this.sendDestinationPortAgent()
    },
    // 【委托拼箱】发送目的港代理
    bbSendDestinationPortAgent() {
      const jobsGroupByDestinationAgent = lodash.groupBy(this.jobs, 'destinationAgent')
      // 【委托拼箱】选择目的港代理
      if (Object.keys(jobsGroupByDestinationAgent).length > 1) {
        const destinationAgents = []
        Object.keys(jobsGroupByDestinationAgent).forEach(key => {
          destinationAgents.push({
            destinationAgent: key,
            count: jobsGroupByDestinationAgent[key].length
          })
        })
        this.destinationAgentSelectDialog.rowData = destinationAgents
        this.destinationAgentSelectDialog.jobsGroupByDestinationAgent = jobsGroupByDestinationAgent
        this.destinationAgentSelectDialog.visible = true
        return
      }
      // 【委托拼箱】发送目的港代理校验
      this.showCheckingSendDestinationAgentWindow(this.jobs, this.isBatch)
    },
    // 【委托拼箱】目的港代理选中处理
    onSelectDestinationAgent(destinationAgent) {
      // 【委托拼箱】发送目的港代理校验
      this.showCheckingSendDestinationAgentWindow(this.destinationAgentSelectDialog.jobsGroupByDestinationAgent[destinationAgent], false)
    },
    async sendDestinationPortAgent() {
      const loading = getLoading4Cxt(this.$parent)
      try {
        let data = null
        if (this.isSop) {
          data = {
            ifFromInstruction: true,
            mailTemplateUuid: this.mailTemplateUuid,
            pushLink: this.pushLink,
            branchId: this.$store.getters.currentOfficeId,
            lob: this.job.lob,
            jobUuids: [this.job.uuid],
            trackingCode: this.trackingCode,
            tenantInstructionUuid: this.tenantInstruction.uuid
          }
        } else {
          data = {
            checkNode: CheckRuleConstants.OPERATION_INSTRUCTION_VALID.code,
            ruleName: this.ruleName,
            lob: this.job.lob,
            seJob: this.job._data || this.job,
            mailTemplateUuid: this.mailTemplateUuid,
            pushLink: this.pushLink
          }
        }
        if (this.dataSendDimension === DATA_SEND_DIMENSION_CONTAINER) {
          data.containerNo = this.jobContainerNoSelectDialog.selectData.containerNo
          data.containerJobKeys = this.jobContainerNoSelectDialog.selectData.jobKeys
          data.exchangeAgent = this.jobContainerNoSelectDialog.selectData.exchangeAgent
        } else {
          if (this.tenantInstruction.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code) {
            data.exchangeAgent = this.exchangeAgentSelectDialog.selectData.exchangeAgent
          } else {
            data.exchangeAgent = 0
          }
        }
        const res = await checkSendDestinationPortAgent(data)
        const { isPass, master, slave, list, isContinue } = res.data
        let masterInfo = ''
        if (master.length > 0) {
          const masterFileInfo = Array.from(master, p => (this.fileTypeCapsMap.get(p) || p) + this.$t('Message.File')).join(', ')
          masterInfo = this.$t('Message.MasterCheckExist', [masterFileInfo])
        }
        let slaveInfo = ''
        if (slave.length > 0) {
          const slaveFileInfo = Array.from(slave, p => (this.fileTypeCapsMap.get(p) || p) + this.$t('Message.File')).join(', ')
          slaveInfo = this.$t('Message.SmallCheckExist', [slaveFileInfo])
        }
        for (const item of list) {
          if (item.info === 'CUSTOMERSELFRELEASE' || item.info === 'CUSTOMERSELFRELEASE_DRAFT') {
            item.info = this.$t('SeaExport.CustomerSelfIssuedFiles')
          }
          if (item.manifestEqualContainerNumCheck) {
            if (item.isExist) {
              item.info = this.$t('Message.ManifestFileNumBox')
            } else {
              item.info = this.$t('Message.ManifestFileNumNotEqualBox', [item.containerCount, item.fileNameCount])
            }
          } else {
            if (item.isExist) {
              const index = item.info.lastIndexOf('.')
              if (index > -1) {
                item.fileType = item.info.substring(index + 1)
                item.info = item.info.substring(0, index)
              }
            } else {
              item.info = this.$t('Message.Lack') + ' ' + (this.fileTypeCapsMap.get(item.info) || item.info)
            }
          }
        }
        this.checkingWindow.isPass = isPass
        this.checkingWindow.masterInfo = masterInfo
        this.checkingWindow.slaveInfo = slaveInfo
        this.checkingWindow.rowData = list
        this.checkingWindow.showNext = isContinue
        this.checkingWindow.matchInstructionTip = ''
        this.checkingWindow.title = ''
        this.checkingWindow.multiFieldSample = null
        this.checkingWindow.visible = true
      } finally {
        loading.close()
      }
    },
    async sendDestinationPortAgentNext() {
      if (this.tenantInstruction.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT.code) {
        this.sendDestinationPortAgentEmailMultiDialog.visible = true
      } else {
        if (this.dataSendDimension === DATA_SEND_DIMENSION_CONTAINER) {
          this.sendDestinationPortAgentEmailDialog.exchangeAgentData = null
          this.sendDestinationPortAgentEmailDialog.jobContainerNoData = this.jobContainerNoSelectDialog.selectData
        } else {
          if (this.tenantInstruction.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT.code) {
            this.sendDestinationPortAgentEmailDialog.exchangeAgentData = this.exchangeAgentSelectDialog.selectData
          } else {
            this.sendDestinationPortAgentEmailDialog.exchangeAgentData = null
          }
          this.sendDestinationPortAgentEmailDialog.jobContainerNoData = null
        }
        this.sendDestinationPortAgentEmailDialog.visible = true
      }
    },
    sendDestinationPortAgentCallback(data) {
      const newJob = {
        sentDestinationPortAgent: data.sentDestinationPortAgent,
        sentDestinationPortAgentDate: data.sentDestinationPortAgentDate,
        version: data.version
      }
      Object.assign(this.job, newJob)
      this.$emit('writebackJob', newJob)
    },
    sendDestinationPortAgentMultiCallback() {
      const newJob = {
        sentDestinationPortAgent: true,
        sentDestinationPortAgentDate: DateUtils.formatStandardDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        version: 1
      }
      Object.assign(this.job, newJob)
      this.$emit('writebackJob', newJob)
    },
    // 【委托拼箱】发送目的港代理校验
    async showCheckingSendDestinationAgentWindow(jobs, showMatchInstructionTip) {
      if (jobs.length > 30) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OperationInstructionBatchTip'))
        return
      }
      const loading = getLoading4Cxt(this.$parent)
      try {
        const res = await checkSendDestinationPortAgentMulti({
          mailTemplateUuid: this.mailTemplateUuid,
          pushLink: this.pushLink,
          branchId: this.$store.getters.currentOfficeId,
          lob: jobs[0].lob,
          jobUuids: jobs.map(p => p.uuid),
          trackingCode: this.trackingCode,
          tenantInstructionUuid: this.tenantInstruction.uuid,
          ruleName: this.ruleName
        })
        const { isPass, list, isContinue, multiFieldSample } = res.data
        for (const item of list) {
          if (item.info === 'CUSTOMERSELFRELEASE' || item.info === 'CUSTOMERSELFRELEASE_DRAFT') {
            item.info = this.$t('SeaExport.CustomerSelfIssuedFiles')
          }
          if (item.manifestEqualContainerNumCheck) {
            if (item.isExist) {
              item.info = this.$t('Message.ManifestFileNumBox')
            } else {
              item.info = this.$t('Message.ManifestFileNumNotEqualBox', [item.containerCount, item.fileNameCount])
            }
          } else {
            if (item.isExist) {
              const index = item.info.lastIndexOf('.')
              if (index > -1) {
                item.fileType = item.info.substring(index + 1)
                item.info = item.info.substring(0, index)
              }
            } else {
              item.info = this.$t('Message.Lack') + ' ' + (this.fileTypeCapsMap.get(item.info) || item.info)
            }
          }
        }
        this.checkingWindow.isPass = isPass
        this.checkingWindow.masterInfo = ''
        this.checkingWindow.slaveInfo = ''
        this.checkingWindow.rowData = list
        this.checkingWindow.showNext = isContinue
        if (showMatchInstructionTip) {
          this.checkingWindow.matchInstructionTip = this.$t('CargoMsg.Cargo_MatchInstructionTip', [this.jobs.length, jobs.length])
        } else {
          this.checkingWindow.matchInstructionTip = ''
        }
        this.checkingWindow.title = this.$t('queryJob.SendVerification')
        this.checkingWindow.multiFieldSample = multiFieldSample || null
        this.checkingWindow.visible = true

        this.sendDestinationPortAgentEmailMultiDialog.jobs = jobs
        this.sendDestinationPortAgentEmailMultiDialog.job = new Job(jobs[0])
        this.sendDestinationPortAgentEmailMultiDialog.destinationAgent = jobs[0].destinationAgent
      } finally {
        loading.close()
      }
    },
    async instructionCallback(data) {
      const loading = getLoading4Cxt(this.$parent)
      await generateInstructionRecord(data).finally(() => {
        loading.close()
      })
      this.$emit('instructionCallback')
    },
    resetOneClickSend() {
      const loading = getLoading4Cxt(this.$parent)
      resetOneClickSend(this.job.uuid).then(res => {
        loading.close()
        const newJob = {
          sentDestinationPortAgent: res.data.sentDestinationPortAgent,
          sentDestinationPortAgentDate: res.data.sentDestinationPortAgentDate,
          version: res.data.version
        }
        Object.assign(this.job, newJob)
        this.$emit('writebackJob', newJob)
        this.instructionCallback({ jobUuids: [this.job.uuid], executeStatus: true, instructionUuid: this.tenantInstruction.uuid })
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>
